/**
 * @generated SignedSource<<8e17b9adb18c2529e142f4d5f7ea2043>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SplitDetailsModal_nftItem$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SplitDetailsContent_nftItem">;
  readonly " $fragmentType": "SplitDetailsModal_nftItem";
};
export type SplitDetailsModal_nftItem$key = {
  readonly " $data"?: SplitDetailsModal_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"SplitDetailsModal_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SplitDetailsModal_nftItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SplitDetailsContent_nftItem"
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "28e586655b501b708653206aa0389368";

export default node;
